
import { useEffect, useState } from 'react';

const HeritageSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const element = document.getElementById('heritage-section');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  const heritageFeatures = [
    {
      icon: 'ri-book-2-line',
      title: '宫廷古方',
      description: '传承自清朝宫廷的珍贵养颜秘方，经过数百年验证的经典配方'
    },
    {
      icon: 'ri-microscope-line',
      title: '现代科学',
      description: '结合现代中医药学研究，确保每一味药材的安全性和有效性'
    },
    {
      icon: 'ri-hand-heart-line',
      title: '匠心工艺',
      description: '采用传统炮制工艺与现代提取技术相结合，保留药材精华'
    },
    {
      icon: 'ri-shield-check-line',
      title: '品质保证',
      description: '严格的质量控制体系，从原料采购到成品出厂全程监控'
    }
  ];

  return (
    <section 
      id="heritage-section"
      className="py-40 relative overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url("https://public.readdy.ai/ai/img_res/58fcc43756d18406f4a73a82ac77265d.jpg")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="max-w-6xl mx-auto px-8 text-center">
        <div className={`transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
          <h2 
            className="text-2xl lg:text-3xl font-light mb-8"
            style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100, color: '#333333' }}
          >
            传承与创新
          </h2>
          <div className="w-32 h-px mx-auto mb-16" style={{ background: 'linear-gradient(to right, transparent, #ED5736, transparent)' }}></div>
          
          <p 
            className="text-sm lg:text-lg max-w-3xl mx-auto mb-20 leading-relaxed font-light"
            style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100, color: '#666666' }}
          >
            我们深知传承的珍贵，更明白创新的必要。在保持古方精髓的同时，融入现代科学技术，让千年智慧在新时代焕发新的生命力。
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {heritageFeatures.map((feature, index) => (
            <div
              key={index}
              className={`transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}
              style={{ transitionDelay: `${(index + 1) * 200}ms` }}
            >
              <div className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
                <div className="flex justify-center mb-6">
                  <div 
                    className="w-16 h-16 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: 'rgba(237, 87, 54, 0.1)' }}
                  >
                    <i className={`${feature.icon} text-2xl`} style={{ color: '#ED5736' }}></i>
                  </div>
                </div>
                
                <h3 
                  className="text-sm lg:text-lg font-light mb-4"
                  style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100, color: '#333333' }}
                >
                  {feature.title}
                </h3>
                
                <p 
                  className="text-xs lg:text-sm leading-relaxed font-light"
                  style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100, color: '#666666' }}
                >
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeritageSection;
